<template>
  <div class="dev-list-map-container">
    <!-- Filter Panel -->
    <div class="form-panel">
      <j-search-select-tag
        :dictOptions="devOptions"
        @change="selectDev"
        placeholder="搜索设备名称、编号"
        style="width: 300px; margin-right: 8px;"
        v-model="filter.devId"
      />
      <j-multi-select-tag
        @change="renderMarkers"
        dictCode="device_run_status"
        placeholder="请选择运行状态"
        type="checkbox"
        v-model="filter.runStatus"
      ></j-multi-select-tag>
      <a-button @click="getDevList" icon="reload" style="margin-left: 8px" />
    </div>

    <!-- Map Container -->
    <div class="map-main" id="map-main"></div>

    <!-- Device Info Modal -->
    <a-modal
      :centered="true"
      :mask="false"
      :maskClosable="false"
      :title="selectedDevice ? selectedDevice.devName : '设备详情'"
      @cancel="infoVisible = false"
      v-model="infoVisible"
      width="400px"
    >
      <template slot="footer">
        <a-button @click="handleControl(selectedDevice)">设备控制</a-button>
        <a-button @click="handleDetail(selectedDevice)" type="primary">详情</a-button>
      </template>

      <div class="pop-container" v-if="selectedDevice">
        <span :class="'tag-' + selectedDevice.runStatus" class="pop-tag">{{ selectedDevice.runStatus_dictText }}</span>
        <span
          :class="'tag-' + (selectedDevice.ifAvailable ? 'free' : 'unavail')"
          class="pop-tag"
        >{{ selectedDevice.ifAvailable ? '启用' : '停用' }}</span>

        <p>
          <strong>名称：</strong>
          {{ selectedDevice.devName }}
        </p>
        <p>
          <strong>地址：</strong>
          {{ selectedDevice.location || '暂无地址信息' }}
        </p>
        <p>
          <strong>运行时间：</strong>
          <template v-if="!selectedDevice.availHours || selectedDevice.availHours.length === 0">
            <a-tag>00:00~24:00</a-tag>
          </template>
          <template v-else>
            <a-tag
              :key="index"
              v-for="(hour, index) in selectedDevice.availHours"
            >{{ hour.startTime }}~{{ hour.endTime }}</a-tag>
          </template>
        </p>
        <img
          :src="selectedDevice.pictureObjId.split(',')[0]"
          alt="设备照片"
          class="pop-pic"
          v-if="selectedDevice.pictureObjId"
        />

        <template v-if="selectedDevice.lastConsumerRecord && selectedDevice.lastConsumerRecord.id">
          <div class="record-info">
            <h4>最近取水记录</h4>
            <p v-if="selectedDevice.lastConsumerRecord.endTime">{{ selectedDevice.lastConsumerRecord.endTime }} 上次加水结束</p>
            <p v-else>{{ selectedDevice.lastConsumerRecord.startTime }} 正在加水</p>
            <p>
              <span class="blue-vertical-line"></span>
              班组：{{ selectedDevice.lastConsumerRecord.groupId_dictText }}
            </p>
            <p>
              <span class="blue-vertical-line"></span>
              取水人：{{ selectedDevice.lastConsumerRecord.consumerUserId_dictText }}
            </p>
            <p v-if="!isThirdAccount">
              <span class="blue-vertical-line"></span>
              企业：{{ selectedDevice.lastConsumerRecord.corpId_dictText }}
            </p>
          </div>
        </template>
      </div>
    </a-modal>

    <!-- Device Control Modal Placeholder -->
    <device-control-modal ref="devControlModal"></device-control-modal>
  </div>
</template>

<script>
  import { getAction } from '@/api/manage'
  // 请确保此路径正确
  import DeviceControlModal from './modules/DeviceControlModal'
  import coordTransform from '@/utils/coordTransform';

  const runstatusStyles = {
    free: '/static/image/wf_marker_free.png',
    busy: '/static/image/wf_marker_busy.png',
    alert: '/static/image/wf_marker_alert.png',
    unAvailable: '/static/image/wf_marker_unavail.png'
  }

  export default {
    name: 'DevListMapNew',
    components: { DeviceControlModal },
    data () {
      return {
        map: null,
        center: [116.397428, 39.90923], // 默认中心点（北京）
        zoom: 12,
        devices: [],
        devOptions: [],
        devMarkers: [], // 用于存储地图标记实例
        filter: {
          devId: null,
          runStatus: 'free,busy,alert' // 默认显示所有状态
        },
        infoVisible: false,
        selectedDevice: null,
        url: {
          list: '/device/devList/list',
          corpList: '/device/devList/corpList',
          devDetail: '/device/devList/queryWfDetail'
        }
      }
    },
    computed: {
      isThirdAccount () {
        return this.$store.getters.userInfo.thirdAccount
      },
      // 根据UI控件筛选设备
      filteredDevices () {
        const { runStatus } = this.filter
        if (!runStatus) return []
        const statusArr = runStatus.split(',')
        return this.devices.filter(device => statusArr.includes(device.runStatus))
      }
    },
    mounted () {
      this.$nextTick(() => {
        // 或 setTimeout(() => { ... }, 0)
        this.initMap()
        this.getDevList()
      })
    },
    beforeDestroy () {
      this.destroyMap()
    },
    methods: {
      // --- 地图方法 ---
      initMap () {
        // 确保天地图API已加载
        if (!window.T || !window.T.Map) {
          this.$message.error('天地图API未加载，请检查index.html是否正确引入！')
          return
        }

        this.map = new window.T.Map('map-main', {
          projection: 'EPSG:4326' // 使用经纬度坐标(WGS84)
        })
        this.map.centerAndZoom(new window.T.LngLat(this.center[0], this.center[1]), this.zoom)

        // 添加地图控件
        this.map.addControl(new window.T.Control.Zoom())
        this.map.addControl(new window.T.Control.Scale())
        this.map.addControl(new window.T.Control.MapType())
      },

      // 销毁地图，防止内存泄漏
      destroyMap () {
        if (this.map) {
          this.map.clearOverLays() // 清除所有覆盖物
          this.map = null
        }
        // 清理DOM容器，确保完全释放
        const mapContainer = document.getElementById('map-main')
        if (mapContainer) {
          mapContainer.innerHTML = ''
        }
      },

      // 渲染设备标记
      renderMarkers () {
        if (!this.map) return

        // 清除旧标记
        this.devMarkers.forEach(marker => this.map.removeOverLay(marker))
        this.devMarkers = []

        this.filteredDevices.forEach(device => {
          let position = null;
          if (device.coordinateWgs84) {
            position = device.coordinateWgs84.replace('，', ',').split(',').map(Number);
          } else if (device.coordinateGcj02) {
            const gcj02 = device.coordinateGcj02.replace('，', ',').split(',').map(Number);
            position = coordTransform.gcj02ToWgs84(gcj02[0], gcj02[1]);
          }

          if (!position || !position[0] || !position[1]) {
            console.warn(`设备 ${device.devName} 的坐标无效，已跳过。`);
            return;
          }

          let iconUrl = runstatusStyles[device.runStatus] || runstatusStyles.free;
          //如果不是故障状态，优先显示不可用
          if (device.runStatus !== 'alert' && !device.ifAvailable) {
            iconUrl = runstatusStyles['unAvailable'];
          }
          const icon = new window.T.Icon({
            iconUrl: iconUrl,
            iconSize: new window.T.Point(32, 32),
            iconAnchor: new window.T.Point(16, 32)
          });
          const marker = new window.T.Marker(new window.T.LngLat(position[0], position[1]), { icon });

          // 为标记添加点击事件
          marker.addEventListener('click', () => this.handleMarkerClick(device))

          this.map.addOverLay(marker)
          this.devMarkers.push(marker)
        })
      },

      // --- 数据与业务逻辑 ---
      getDevList () {
        const listUrl = this.isThirdAccount ? this.url.corpList : this.url.list
        getAction(listUrl, { checkAvail: true, pageSize: 999999 }).then(res => {
          if (res.success) {
            this.devices = res.result.records
            this.devOptions = this.devices.map(device => ({
              value: device.id,
              text: `${device.devName}`
            }))
            this.renderMarkers() // 获取数据后渲染标记
          } else {
            this.$message.error(res.message)
          }
        })
      },

      async handleMarkerClick (device) {
        this.selectedDevice = device
        try {
          const res = await getAction(this.url.devDetail, { id: device.id })
          if (res.success) {
            this.selectedDevice = {
              ...device, // 保留列表中的基本数据
              ...res.result, // 使用详情数据覆盖和补充
              availHours: res.result.availHours || [],
              lastConsumerRecord: res.result.lastConsumerRecord || null
            }
          } else {
            this.$message.error('获取设备详情失败: ' + res.message)
          }
        } catch (error) {
          console.error('获取设备详情失败:', error)
          this.$message.error('获取设备详情失败')
        } finally {
          this.infoVisible = true
        }
      },

      selectDev (id) {
        if (!id) return
        const device = this.devices.find(d => d.id === id)
        if (device) {
          const position = device.coordinateGcj02
            ? device.coordinateGcj02.replace('，', ',').split(',').map(Number)
            : [device.lng, device.lat]

          if (position && position[0] && position[1]) {
            this.map.panTo(new window.T.LngLat(position[0], position[1]))
            this.handleMarkerClick(device)
          }
        }
      },

      handleDetail (device) {
        // 假设你项目中使用了 $bus 作为事件总线
        this.$bus.$emit('to-page-detail', {
          name: 'FusionDevice',
          id: device.id,
          type: 'drawer'
        })
      },

      handleControl (device) {
        this.$refs.devControlModal.edit({ id: device.id })
        this.$refs.devControlModal.title = `设备控制-【${device.devName}】`
      }
    }
  }
</script>

<style lang="less" scoped>
  .dev-list-map-container {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
  }

  .form-panel {
    position: absolute;
    top: 10px;
    left: 50px;
    z-index: 999;
    padding: 10px;
    display: flex;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }

  .map-main {
    width: 100%;
    height: 100%;
    flex: 1;
  }

  /* --- 弹窗样式 --- */
  .pop-container {
    p {
      margin-bottom: 8px;
      color: #333;
      strong {
        color: #000;
      }
    }
  }

  .pop-tag {
    display: inline-block;
    padding: 0 6px;
    height: 20px;
    line-height: 20px;
    border-radius: 2px;
    font-size: 12px;
    margin-right: 8px;
    margin-bottom: 8px;
  }

  .tag-free {
    background-color: #f6ffed;
    border: 1px solid #b7eb8f;
    color: #52c41a;
  }

  .tag-busy {
    background-color: #fff7e6;
    border: 1px solid #ffd591;
    color: #fa8c16;
  }

  .tag-alert {
    color: #fff;
    background: #9e9e9e;
    border-color: #b8b8b8;
  }

  .tag-unavail {
    background-color: #fff1f0;
    border: 1px solid #efd872;
    color: #d3ae0b;
  }

  .pop-pic {
    display: block;
    max-width: 100%;
    max-height: 200px;
    margin: 10px 0;
    border-radius: 4px;
  }

  .record-info {
    margin-top: 16px;
    padding: 12px;
    background-color: #f9f9f9;
    border-radius: 4px;
    border: 1px solid #eee;

    h4 {
      margin-top: 0;
      margin-bottom: 8px;
      font-size: 14px;
    }

    p {
      margin-bottom: 4px;
      color: #666;
      display: flex;
      align-items: center;
    }
  }

  .blue-vertical-line {
    display: inline-block;
    width: 4px;
    height: 14px;
    background-color: #1890ff;
    margin-right: 8px;
  }

  /deep/ .ant-modal-body {
    padding: 16px;
  }
</style>